import jwtAuthAxios from "./auth/jwtAuth";

const printerServices = {};

printerServices.getPrinters = async (params = null) => {
    const { data } = await jwtAuthAxios.get(`/printers${params || ""}`);
    return data;
};

printerServices.getPrinter = async (id, params = null) => {
    const { data } = await jwtAuthAxios.get(`/printers/${id}${params || ""}`);
    return data;
};

printerServices.getEditOptions = async () => {
    const { data } = await jwtAuthAxios.get(`/printers/edit_options`);
    return data;
};

printerServices.createPrinter = async (params, body) => {
    const { data } = await jwtAuthAxios.post(`/printers${params ?? ""}`, body);
    return data;
};

printerServices.savePrinter = async (id, params, body) => {
    const { data } = await jwtAuthAxios.put(`/printers/${id}${params ?? ""}`, body);
    return data;
};

printerServices.deletePrinter = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/printers/${id}`);
    return data;
};

printerServices.togglePrinterActivation = async (id, params = null) => {
    const { data } = await jwtAuthAxios.post(`/printers/${id}/toggle_activation${params || ""}`);
    return data;
};

export default printerServices;
